export function secrecyMobile(mobile) {
    mobile = String(mobile);
    if (!/\d{11}/.test(mobile)) {
      return mobile;
    }
    return mobile.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
  }

export function secrecyIdCard(IdCard) {
  return IdCard.replace(/^(.{3})(?:\d+)(.{2})$/, "$1******$2")   
// 匹配身份证号前6位和后4位的正则表达式,身份证号脱敏，将中间8位替换为“*”
} 